import React, { useEffect, useState } from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import AddOrderForm from "../../../UI/Orders/add-by-offer";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

const AddOrderByOfferPanel = () => {
  const [isPanelsLoading, setIsPanelsLoading] = useState(true);
  const [isUsersLoading, setUsersLoading] = useState(true);
  const [isOffersLoading, setIsOffersLoading] = useState(true);
  const [offers, setOffers] = useState([]);
  const [panels, setPanels] = useState([]);
  const [users, setUsers] = useState([]);

  const getPanels = async () => {
    setIsPanelsLoading(true);
    const { response } = await Helper.Get({
      url: api_Routes.Groups.PanelView,
      hasToken: true,
    });
    if (response) {
      setPanels(response);
    }
    setIsPanelsLoading(false);
  };

  const getUsers = async () => {
    setUsersLoading(true);
    const { response, message } = await Helper.Get({
      url: `${api_Routes.Users.ViewAll}`,
      hasToken: true,
    });
    if (response) {
      setUsers(response?.data);
    }
    setUsersLoading(false);
  };

  const getOffers = async () => {
    setIsOffersLoading(true);
    const { response, message } = await Helper.Get({
      url: api_Routes.Offers.View,
      hasToken: true,
    });
    if (response) {
      setOffers(response.data);
    }
    setIsOffersLoading(false);
  };

  useEffect(() => {
    getPanels();
    getOffers();
    getUsers();
  }, []);

  return (
    <div>
      <PanelHead title="Add order" />
      <PanelBody
        content={
          <AddOrderForm
            panels={panels}
            isPanelsLoading={isPanelsLoading}
            users={users}
            isUsersLoading={isUsersLoading}
            isOffersLoading={isOffersLoading}
            offers={offers}
          />
        }
      />
    </div>
  );
};

export default React.memo(AddOrderByOfferPanel);
